import INTEGRATION_LOGO from "../assets/smart-pension-logo.svg";

const INTEGRATION_NAME = "Smart Pension";
const INTEGRATION_TYPE = "pension";
const INTEGRATION_VARIABLE = "smartPension";
const INTEGRATION_IN_PROGRESS = false;

export { INTEGRATION_NAME, INTEGRATION_TYPE, INTEGRATION_VARIABLE, INTEGRATION_LOGO, INTEGRATION_IN_PROGRESS };